import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=467efd64"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=467efd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports